import { useEffect } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { useBranchStore } from '@/stores';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const DeviceBranchAssign = ({ device, canAssign, onSaved }) => {
  const { branches, fetchBranches } = useBranchStore();
  useEffect(() => { fetchBranches(); }, [fetchBranches]);
  const current = device.assigned_branch_id || 'none';
  const save = async (v) => {
    const bid = v === 'none' ? '' : v;
    const name = branches.find((b) => b.id === bid)?.name;
    if (!window.confirm(bid ? `Lock this device to ${name}? Staff logging in here will always work in ${name}.` : 'Remove the branch lock from this device?')) return;
    try {
      await api.put(`/cashier/devices/${device.device_id}`, { assigned_branch_id: bid });
      toast.success(bid ? `Device locked to ${name}` : 'Branch lock removed');
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || 'Assignment failed'); }
  };
  if (!canAssign) return <span className="text-xs" data-testid={`device-assigned-${device.device_id}`}>{device.assigned_branch_name || '—'}</span>;
  return (
    <Select value={current} onValueChange={save}>
      <SelectTrigger className="h-7 w-36 text-xs" data-testid={`device-assign-${device.device_id}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Not locked</SelectItem>
        {branches.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
